import { render, staticRenderFns } from "./Estudent.vue?vue&type=template&id=4f28e57f"
import script from "./Estudent.vue?vue&type=script&lang=js"
export * from "./Estudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports